"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const ArrowRight_1 = __importDefault(require("@mui/icons-material/ArrowRight"));
const IconMenuItem_1 = __importDefault(require("./IconMenuItem"));
const NestedMenuItem = (0, react_1.forwardRef)((_a, ref) => {
    var { parentMenuOpen, label, rightIcon = <ArrowRight_1.default />, leftIcon = null, children, className, tabIndex: tabIndexProp, ContainerProps: ContainerPropsProp = {}, MenuProps, disabled = false } = _a, MenuItemProps = __rest(_a, ["parentMenuOpen", "label", "rightIcon", "leftIcon", "children", "className", "tabIndex", "ContainerProps", "MenuProps", "disabled"]);
    const { ref: containerRefProp } = ContainerPropsProp, ContainerProps = __rest(ContainerPropsProp, ["ref"]);
    const menuItemRef = (0, react_1.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: TODO: fix later
    (0, react_1.useImperativeHandle)(ref, () => menuItemRef.current);
    const containerRef = (0, react_1.useRef)(null);
    (0, react_1.useImperativeHandle)(containerRefProp, () => containerRef.current);
    const menuContainerRef = (0, react_1.useRef)(null);
    const [isSubMenuOpen, setIsSubMenuOpen] = (0, react_1.useState)(false);
    const handleMouseEnter = (e) => {
        var _a;
        setIsSubMenuOpen(true);
        (_a = ContainerProps === null || ContainerProps === void 0 ? void 0 : ContainerProps.onMouseEnter) === null || _a === void 0 ? void 0 : _a.call(ContainerProps, e);
    };
    const handleMouseLeave = (e) => {
        var _a;
        setIsSubMenuOpen(false);
        (_a = ContainerProps === null || ContainerProps === void 0 ? void 0 : ContainerProps.onMouseLeave) === null || _a === void 0 ? void 0 : _a.call(ContainerProps, e);
    };
    // Check if any immediate children are active
    const isSubmenuFocused = () => {
        var _a, _b, _c;
        if ((_a = menuContainerRef === null || menuContainerRef === void 0 ? void 0 : menuContainerRef.current) === null || _a === void 0 ? void 0 : _a.children) {
            const active = (_c = (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.ownerDocument.activeElement) !== null && _c !== void 0 ? _c : null;
            // eslint-disable-next-line no-restricted-syntax
            for (const child of Array.from(menuContainerRef.current.children)) {
                if (child === active) {
                    return true;
                }
            }
        }
        return false;
    };
    const handleFocus = (e) => {
        var _a;
        if (e.target === containerRef.current) {
            setIsSubMenuOpen(true);
        }
        (_a = ContainerProps === null || ContainerProps === void 0 ? void 0 : ContainerProps.onFocus) === null || _a === void 0 ? void 0 : _a.call(ContainerProps, e);
    };
    const handleKeyDown = (e) => {
        var _a, _b, _c;
        if (e.key === 'Escape') {
            return;
        }
        if (isSubmenuFocused()) {
            e.stopPropagation();
        }
        const active = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument.activeElement;
        if (e.key === 'ArrowLeft' && isSubmenuFocused()) {
            (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
        if (e.key === 'ArrowRight' &&
            e.target === containerRef.current &&
            e.target === active) {
            const firstChild = (_c = menuContainerRef.current) === null || _c === void 0 ? void 0 : _c.children[0];
            firstChild === null || firstChild === void 0 ? void 0 : firstChild.focus();
        }
    };
    const open = isSubMenuOpen && parentMenuOpen;
    // Root element must have a `tabIndex` attribute for keyboard navigation
    let tabIndex;
    if (!disabled) {
        tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    }
    return (<div {...ContainerProps} ref={containerRef} onFocus={handleFocus} tabIndex={tabIndex} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onKeyDown={handleKeyDown} role="menu">
      <IconMenuItem_1.default MenuItemProps={MenuItemProps} className={className} 
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: TODO: fix later
    ref={menuItemRef} leftIcon={leftIcon} rightIcon={rightIcon} label={label}/>

      <Menu_1.default 
    // Set pointer events to 'none' to prevent the invisible Popover div
    // from capturing events for clicks and hovers
    style={{ pointerEvents: 'none' }} anchorEl={menuItemRef.current} anchorOrigin={{ vertical: 'center', horizontal: 'left' }} transformOrigin={{ vertical: 'center', horizontal: 310 }} elevation={4} open={open} autoFocus={false} disableAutoFocus disableEnforceFocus onClose={() => {
            setIsSubMenuOpen(false);
        }} {...MenuProps}>
        <div ref={menuContainerRef} style={{ pointerEvents: 'auto' }}>
          {children}
        </div>
      </Menu_1.default>
    </div>);
});
exports.default = NestedMenuItem;
